import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appAmountCommaFormatter]',
  standalone: true
})
export class AmountCommaFormatterDirective implements AfterViewInit, OnDestroy {
  @Input({ required: true }) amountType:
    | 'AMOUNT'
    | 'FLAT'
    | 'PERCENTAGE'
    | null = null;
  private sub?: Subscription;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl,
  ) {}

  ngAfterViewInit(): void {
    const value = this.control.control?.value;
    if (value !== null && value !== undefined) {
      this.applyFormatting(String(value));
    }

    this.sub = this.control.control?.valueChanges?.subscribe((value) => {
      if (value !== null && value !== undefined) {
        this.applyFormatting(String(value));
      }
    });
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.applyFormatting(input.value, true);
  }

  private applyFormatting(value: string, fromUser = false): void {
    let raw = this.nepaliToEnglish(value)
      .replace(/,/g, '')
      .replace(/[^\d.]/g, '');

    const parts = raw.split('.');
    if (parts.length > 2) {
      raw = parts[0] + '.' + parts.slice(1).join('');
    }

    const numericValue = raw ? Number(raw) : null;

    this.control.control?.setValue(numericValue, { emitEvent: fromUser });

    if (this.amountType === 'AMOUNT' || this.amountType === 'FLAT') {
      this.el.nativeElement.value = this.formatNepaliComma(raw);
    } else {
      this.el.nativeElement.value = raw;
    }
  }

  private formatNepaliComma(value: string): string {
    if (!value) return '';

    const parts = value.split('.');
    const integer = parts[0];
    const decimal = parts.length > 1 ? '.' + parts[1] : '';

    if (integer.length <= 3) {
      return integer + decimal;
    }

    const lastThree = integer.slice(-3);
    const rest = integer.slice(0, -3);

    return (
      rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree + decimal
    );
  }

  private nepaliToEnglish(value: string): string {
    const map: Record<string, string> = {
      '०': '0',
      '१': '1',
      '२': '2',
      '३': '3',
      '४': '4',
      '५': '5',
      '६': '6',
      '७': '7',
      '८': '8',
      '९': '9',
    };

    return value.replace(/[०-९]/g, (d) => map[d]);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
